module.exports = __webpack_public_path__ + "img/combine_cells.d107055.svg";